import { styled } from 'styled-components';
import { Layout } from 'antd';
const PageStyled = styled(Layout)`
    height:100vh;
`;

export default PageStyled;
